<template>
  <div class="adminAnalytics-page pa-6">
    <p-progress-linear v-if="isLoading " :indeterminate="true" color="base" height="10">
    </p-progress-linear>
    <p-container v-if="!isLoading && page.adminAnalyticsDataSource">
      <!-- Title -->
      <h2 class="mb-4">
        {{ $t('page.dashboard.admin.zahlen.title') }}
      </h2>
      <p-row>
        <!-- Search Field -->
        <p-col xs12 md6 lg3>
          <p-text-field v-model="page.adminAnalyticsDataSource.filter.searchCriteria" clearable :label="$t('core.app.search')" context-icon="search"></p-text-field>
        </p-col>
        <p-col xs12 md6 lg3>
          <p-select
            v-model="page.adminAnalyticsDataSource.filter.selectedOrganisationId"
            clearable
            :label="$t('page.companies.select.organisationName')"
            :items="page.organisationNameItems"
            @input="page.refreshAnalytics()"
          ></p-select>
        </p-col>
        <!-- Event Filter -->
        <p-col xs12 md6 lg3>
          <p-select
            v-model="page.adminAnalyticsDataSource.filter.eventIdentifier"
            :label="$t('page.events.select.eventName')"
            :items="page.eventItems"
            @input="page.refreshAnalytics()"
          ></p-select>
        </p-col>
      </p-row>
      <p-list-view
        v-model="page.adminAnalyticsList"
        :columns="page.companyColumns"
        :pagination.sync="page.adminAnalyticsDataSource.paging"
        :loading="page.adminAnalyticsDataSource.isLoading"
      >
        <template slot="table-actions">
          <!-- Refresh Button -->
          <p-button @click="page.refreshAnalytics()">
            <p-icon>refresh</p-icon>
          </p-button>
        </template>
        <template #actions="{ row }">
          <p-col xs12 sm6 md10>
            <p-row dense>
              <p-col xs6>
                <p-button @click="page.gotoDetail(row.values.companyId)">
                  <p-icon>arrow_forward</p-icon>
                </p-button>
              </p-col>
            </p-row>
          </p-col>
        </template>
      </p-list-view>
    </p-container>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import { IDataSourcePaging } from '@glittr/frontend-core/src/core/v2/data/data-source';
  import OrganisationAnalyticsPage from './analytics.vue.model';

  export default Vue.extend({
    name: 'OrganisationAnalytics',
    auth: true,
    data: () => ({
      page: new OrganisationAnalyticsPage(),
      isLoading: false,
      innerPagination: {} as IDataSourcePaging,
    }),
    computed: {
      isAdmin(): boolean {
        let isAdmin = false;
        if (this.$auth.isLoggedIn) {
          isAdmin = this.$auth.isInRole('Admin', 'HostAdmin');
        }
        return isAdmin;
      },
    },
    watch: {
      'page.dataSource.paging': {
        handler() {
          this.innerPagination = this.page.dataSource.paging;
        },
      },
    },
    async beforeMount() {
      await this.page.initialize();
    },
  });
</script>
